// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1vw;
  border-bottom: 1px solid var(--ion-color-primary);
  background: var(--ion-white-primary);
}
.modalHeader .modal-title {
  font-size: 18px;
  padding: 0 5vw;
  font-weight: 600;
  color: var(--ion-color-primary);
}
.modalHeader .close-button {
  cursor: pointer;
  padding: 0;
  margin: 1vw;
  display: flex;
  height: 8vw;
  width: 8vw;
  border-radius: 50%;
  background: var(--ion-color-primary);
  transition: background 0.2s ease;
  justify-content: center;
  align-items: center;
}
.modalHeader .close-button:hover {
  background: var(--ion-color-danger);
}
.modalHeader .close-button .close-icon {
  margin: 1vw;
  height: 6vw;
  width: 6vw;
  font-weight: bold;
  color: var(--ion-text-primary);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modalContainer {
  padding: 1vw;
  max-height: 70vh;
  overflow-y: auto;
  background: var(--ion-color-white);
}

.warning-container.danger .warning-message {
  background-color: var(--ion-ultra-danger);
  border-left: 4px solid var(--ion-color-danger);
}
.warning-container.danger .warning-message .warning-icon {
  color: var(--ion-text-danger);
}
.warning-container.warning .warning-message {
  background-color: var(--ion-ultra-warning);
  border-left: 4px solid var(--ion-color-warning);
}
.warning-container.warning .warning-message .warning-icon {
  color: var(--ion-text-warning);
}

.menu-item-info {
  text-align: center;
  margin: 3vw;
  margin-bottom: 8vw;
}
.menu-item-info h3 {
  margin: 2vw;
  font-weight: 600;
  font-size: 16px;
  color: var(--ion-text-white);
}
.menu-item-info .item-description {
  color: var(--ion-text-white);
  font-size: 12px;
  margin: 0;
}

.warning-message {
  display: flex;
  align-items: flex-start;
  padding: 2vw;
  border-radius: 12px;
  margin: 3vw;
  margin-bottom: 8vw;
}
.warning-message .warning-icon {
  font-size: 24px;
  margin-right: 12px;
  margin-top: 2px;
  flex-shrink: 0;
}
.warning-message p {
  margin: 0;
  line-height: 1.5;
  white-space: pre-line;
}

.replacements-section {
  margin-bottom: 24px;
}
.replacements-section h4 {
  margin: 2vw;
  font-weight: 600;
  color: var(--ion-text-white);
}

.replacement-slider .replacement-scroll-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.replacement-slider .replacement-scroll-container .replacement-item {
  min-width: 70vw;
  flex-shrink: 0;
  cursor: pointer;
  scroll-snap-align: start;
  transition: transform 0.2s ease;
  transform: scale(0.9);
  border: 1px solid var(--ion-pass-white);
  transform-origin: 0% 50%;
  margin: 0 auto;
  border-radius: 15px;
}
.replacement-slider .replacement-scroll-container .replacement-item:active {
  transform: scale(0.925);
  border: 1px solid var(--ion-color-primary);
  transform-origin: 0% 50%;
  margin: 0 auto;
  border-radius: 15px;
}
.replacement-slider .replacement-scroll-container .replacement-item.selected .replacement-card {
  border-color: var(--ion-color-success);
  background-color: var(--ion-light-success);
}

.replacement-card {
  display: flex;
  flex-direction: column;
  background: var(--ion-color-white);
  border: 2px solid var(--ion-color-white);
  border-radius: 12px;
  padding: 12px;
  height: 100%;
  position: relative;
  transition: all 0.2s ease;
}
.replacement-card img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 8px;
}
.replacement-card .replacement-info {
  flex: 1;
}
.replacement-card .replacement-info h5 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-text-white);
}
.replacement-card .replacement-info p {
  margin: 0 0 8px 0;
  font-size: 12px;
  color: var(--ion-text-white);
  line-height: 1.3;
}
.replacement-card .replacement-nutrition {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.replacement-card .replacement-nutrition span {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: var(--ion-color-white);
  color: var(--ion-text-white);
}
.replacement-card .replacement-nutrition span.calories {
  background-color: var(--ion-color-primary-tint);
  color: var(--ion-color-primary);
}
.replacement-card .replacement-nutrition span.protein {
  background-color: var(--ion-color-secondary-tint);
  color: var(--ion-color-secondary);
}
.replacement-card .selection-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 20px;
  color: var(--ion-text-white);
  background: var(--ion-color-white);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.modalFooter {
  padding: 20px;
  border-top: 1px solid var(--ion-color-white);
  background: var(--ion-color-white);
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
}
.action-buttons .modalbtn {
  margin: 0 auto;
  border-radius: 8px;
  padding: 0;
  font-weight: 500;
}
.action-buttons .modalbtn.cancel-btn {
  order: 3;
}
.action-buttons .modalbtn.confirm-btn {
  order: 1;
}
.action-buttons .modalbtn.replacement-btn {
  order: 2;
}

.additional-info {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  background-color: var(--ion-color-danger);
  border-radius: 8px;
  border-left: 4px solid var(--ion-color-danger);
}
.additional-info .info-icon {
  font-size: 16px;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}
.additional-info ion-icon {
  font-size: 18px;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
  color: var(--ion-color-danger);
}
.additional-info p {
  margin: 0;
  font-size: 12px;
  color: var(--ion-color-danger-shade);
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergy-confirmation-modal/allergy-confirmation-modal.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,iDAAA;EACA,oCAAA;AAAF;AAEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,+BAAA;AAAJ;AAGE;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;EACA,gCAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAGI;EACE,mCAAA;AADN;AAII;EACE,WAAA;EACA,WAAA;EACA,UAAA;EAEA,iBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHN;;AASA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AANF;;AAWI;EACE,yCAAA;EACA,8CAAA;AARN;AAUM;EACE,6BAAA;AARR;AAcI;EACE,0CAAA;EACA,+CAAA;AAZN;AAcM;EACE,8BAAA;AAZR;;AAkBA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AAfF;AAiBE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AAfJ;AAkBE;EACE,4BAAA;EACA,eAAA;EACA,SAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAjBF;AAmBE;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;AAlBJ;;AAsBA;EACE,mBAAA;AAnBF;AAqBE;EACE,WAAA;EACA,gBAAA;EACA,4BAAA;AAnBJ;;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AArBJ;AAuBI;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uCAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;AArBN;AAuBM;EACE,uBAAA;EACA,0CAAA;EACA,wBAAA;EACA,cAAA;EACA,mBAAA;AArBR;AAyBQ;EACE,sCAAA;EACA,0CAAA;AAvBV;;AA8BA;EACE,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AA3BF;AA6BE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA3BJ;AA8BE;EACE,OAAA;AA5BJ;AA8BI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AA5BN;AA+BI;EACE,iBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;AA7BN;AAiCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA/BJ;AAiCI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;AA/BN;AAiCM;EACE,+CAAA;EACA,+BAAA;AA/BR;AAkCM;EACE,iDAAA;EACA,iCAAA;AAhCR;AAqCE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,4BAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAnCJ;;AAwCA;EACE,aAAA;EACA,4CAAA;EACA,kCAAA;AArCF;;AAwCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AArCF;AAuCE;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AArCJ;AAuCI;EACE,QAAA;AArCN;AAwCI;EACE,QAAA;AAtCN;AAyCI;EACE,QAAA;AAvCN;;AA4CA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,yCAAA;EACA,kBAAA;EACA,8CAAA;AAzCF;AA2CE;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAzCJ;AA4CE;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,8BAAA;AA1CJ;AA6CE;EACE,SAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;AA3CJ","sourcesContent":["// Modal header styling\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1vw;\n  border-bottom: 1px solid var(--ion-color-primary);\n  background: var(--ion-white-primary);\n\n  .modal-title {\n    font-size: 18px;\n    padding: 0 5vw;\n    font-weight: 600;\n    color: var(--ion-color-primary);\n  }\n\n  .close-button {\n    cursor: pointer;\n    padding: 0;\n    margin: 1vw;\n    display: flex;\n    height: 8vw;\n    width: 8vw;\n    border-radius: 50%;\n    background: var(--ion-color-primary);\n    transition: background 0.2s ease;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      background: var(--ion-color-danger);\n    }\n\n    .close-icon {\n      margin: 1vw;\n      height: 6vw;\n      width: 6vw;\n      // font-size: 24px;\n      font-weight: bold;\n      color: var(--ion-text-primary);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n\n// Modal container styling\n.modalContainer {\n  padding: 1vw;\n  max-height: 70vh;\n  overflow-y: auto;\n  background: var(--ion-color-white);\n}\n\n.warning-container {\n  &.danger {\n    .warning-message {\n      background-color: var(--ion-ultra-danger);\n      border-left: 4px solid var(--ion-color-danger);\n\n      .warning-icon {\n        color: var(--ion-text-danger);\n      }\n    }\n  }\n\n  &.warning {\n    .warning-message {\n      background-color: var(--ion-ultra-warning);\n      border-left: 4px solid var(--ion-color-warning);\n\n      .warning-icon {\n        color: var(--ion-text-warning);\n      }\n    }\n  }\n}\n\n.menu-item-info {\n  text-align: center;\n  margin: 3vw;\n  margin-bottom: 8vw;\n\n  h3 {\n    margin: 2vw;\n    font-weight: 600;\n    font-size: 16px;\n    color: var(--ion-text-white);\n  }\n\n  .item-description {\n    color: var(--ion-text-white);\n    font-size: 12px;\n    margin: 0;\n  }\n}\n\n.warning-message {\n  display: flex;\n  align-items: flex-start;\n  padding: 2vw;\n  border-radius: 12px;\n  margin: 3vw;\n  margin-bottom: 8vw;\n\n  .warning-icon {\n    font-size: 24px;\n    margin-right: 12px;\n    margin-top: 2px;\n    flex-shrink: 0;\n  }\n\n  p {\n    margin: 0;\n    line-height: 1.5;\n    white-space: pre-line;\n  }\n}\n\n.replacements-section {\n  margin-bottom: 24px;\n\n  h4 {\n    margin: 2vw;\n    font-weight: 600;\n    color: var(--ion-text-white);\n  }\n}\n\n.replacement-slider {\n  .replacement-scroll-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .replacement-item {\n      min-width: 70vw;\n      flex-shrink: 0;\n      cursor: pointer;\n      scroll-snap-align: start;\n      transition: transform 0.2s ease;\n      transform: scale(0.9);\n      border: 1px solid var(--ion-pass-white);\n      transform-origin: 0% 50%;\n      margin: 0 auto;\n      border-radius: 15px;\n\n      &:active {\n        transform: scale(0.925);\n        border: 1px solid var(--ion-color-primary);\n        transform-origin: 0% 50%;\n        margin: 0 auto;\n        border-radius: 15px;\n      }\n\n      &.selected {\n        .replacement-card {\n          border-color: var(--ion-color-success);\n          background-color: var(--ion-light-success);\n        }\n      }\n    }\n  }\n}\n\n.replacement-card {\n  display: flex;\n  flex-direction: column;\n  background: var(--ion-color-white);\n  border: 2px solid var(--ion-color-white);\n  border-radius: 12px;\n  padding: 12px;\n  height: 100%;\n  position: relative;\n  transition: all 0.2s ease;\n\n  img {\n    width: 100%;\n    height: 80px;\n    object-fit: cover;\n    border-radius: 8px;\n    margin-bottom: 8px;\n  }\n\n  .replacement-info {\n    flex: 1;\n\n    h5 {\n      margin: 0 0 4px 0;\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--ion-text-white);\n    }\n\n    p {\n      margin: 0 0 8px 0;\n      font-size: 12px;\n      color: var(--ion-text-white);\n      line-height: 1.3;\n    }\n  }\n\n  .replacement-nutrition {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n\n    span {\n      font-size: 11px;\n      padding: 2px 6px;\n      border-radius: 4px;\n      background-color: var(--ion-color-white);\n      color: var(--ion-text-white);\n\n      &.calories {\n        background-color: var(--ion-color-primary-tint);\n        color: var(--ion-color-primary);\n      }\n\n      &.protein {\n        background-color: var(--ion-color-secondary-tint);\n        color: var(--ion-color-secondary);\n      }\n    }\n  }\n\n  .selection-indicator {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    font-size: 20px;\n    color: var(--ion-text-white);\n    background: var(--ion-color-white);\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n  }\n}\n\n// Modal footer styling\n.modalFooter {\n  padding: 20px;\n  border-top: 1px solid var(--ion-color-white);\n  background: var(--ion-color-white);\n}\n\n.action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n\n  .modalbtn {\n    margin: 0 auto;\n    border-radius: 8px;\n    padding: 0;\n    font-weight: 500;\n\n    &.cancel-btn {\n      order: 3;\n    }\n\n    &.confirm-btn {\n      order: 1;\n    }\n\n    &.replacement-btn {\n      order: 2;\n    }\n  }\n}\n\n.additional-info {\n  display: flex;\n  align-items: flex-start;\n  padding: 12px;\n  background-color: var(--ion-color-danger);\n  border-radius: 8px;\n  border-left: 4px solid var(--ion-color-danger);\n\n  .info-icon {\n    font-size: 16px;\n    margin-right: 8px;\n    margin-top: 2px;\n    flex-shrink: 0;\n  }\n\n  ion-icon {\n    font-size: 18px;\n    margin-right: 8px;\n    margin-top: 2px;\n    flex-shrink: 0;\n    color: var(--ion-color-danger);\n  }\n\n  p {\n    margin: 0;\n    font-size: 12px;\n    color: var(--ion-color-danger-shade);\n    line-height: 1.4;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
